var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArticleCreated(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#D0E7DF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9167 24.3334H18.0834M16.0001 8.64708V7.66669M21.2084 10.6079L22.2501 9.62747M10.7917 10.6079L9.75008 9.62747M8.70841 14.5294H7.66675M24.3334 14.5294H23.2917M16.0001 11.0981C17.0577 11.0974 18.0845 11.4335 18.9135 12.0515C19.7425 12.6696 20.3251 13.5334 20.5666 14.5025C20.8081 15.4716 20.6943 16.4891 20.2437 17.3896C19.793 18.2901 19.0321 19.0208 18.0845 19.4628L18.0834 20.4118C18.0834 20.9318 17.8639 21.4306 17.4732 21.7983C17.0825 22.166 16.5526 22.3726 16.0001 22.3726C15.4475 22.3726 14.9176 22.166 14.5269 21.7983C14.1362 21.4306 13.9167 20.9318 13.9167 20.4118V19.4628C12.9692 19.0208 12.2083 18.2902 11.7577 17.3898C11.307 16.4894 11.1931 15.472 11.4345 14.5029C11.6758 13.5339 12.2582 12.6701 13.0871 12.052C13.916 11.4339 14.9426 11.0977 16.0001 11.0981Z",
    stroke: "#344868",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArticleCreated);
export default __webpack_public_path__ + "static/media/article-created.d55a39bcbf95f05b7132305a10704728.svg";
export { ForwardRef as ReactComponent };